/**
 * Cross-shell keyboard shortcuts for operational desks (same behavior, different chrome).
 */
export const OPERATIONAL_KEYBOARD = {
  FOCUS_SEARCH: '/',
  NEXT_QUEUE_ITEM: 'ArrowDown',
  PREV_QUEUE_ITEM: 'ArrowUp',
  ACTIVATE: 'Enter',
  REFRESH: 'r',
  ESCAPE: 'Escape',
  ACKNOWLEDGE_ALERT: 'a',
};

export function isTypingTarget(target) {
  if (!target) return false;
  const tag = target.tagName?.toLowerCase?.() ?? '';
  return tag === 'input' || tag === 'textarea' || tag === 'select' || target.isContentEditable;
}
